import { render, staticRenderFns } from "./FeedbackFormBlock.vue?vue&type=template&id=4afba8b2&scoped=true&"
import script from "./FeedbackFormBlock.vue?vue&type=script&lang=js&"
export * from "./FeedbackFormBlock.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackFormBlock.vue?vue&type=style&index=0&id=4afba8b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afba8b2",
  null
  
)

export default component.exports